/**
 * Проверяем, что открыт браузер Safari
 */

 function isSafari() {
   return (/Safari\//).test(navigator.userAgent) && !(/Chrom(e|ium)\//).test(navigator.userAgent);
 }

 export default isSafari;
